import React from 'react';
import { Box, Button, Container, Typography } from '@material-ui/core';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import SpeedIcon from '@material-ui/icons/Speed';
import BarChartIcon from '@material-ui/icons/BarChart';
import SportsKabaddiIcon from '@material-ui/icons/SportsKabaddi';
import DevicesIcon from '@material-ui/icons/Devices';
import ChangeHistoryIcon from '@material-ui/icons/ChangeHistory';

function detectPlatform(): 'android' | 'ios' | 'unknown' {
  const ua = navigator.userAgent || '';
  if (/android/i.test(ua)) return 'android';
  if (/iphone|ipad|ipod/i.test(ua)) return 'ios';
  return 'unknown';
}

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=at.pyramidcup';
const APP_STORE_URL = 'https://apps.apple.com/app/pyramiden-cup/id6759214277';

interface FeatureItemProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

function FeatureItem({ icon, title, description }: FeatureItemProps) {
  return (
    <Box display="flex" alignItems="flex-start" mb={2.5}>
      <Box
        mr={2}
        style={{
          backgroundColor: '#ee6c4d',
          borderRadius: 12,
          padding: 8,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        {icon}
      </Box>
      <Box>
        <Typography variant="subtitle1" style={{ fontWeight: 700, color: '#3d5a80', lineHeight: 1.3 }}>
          {title}
        </Typography>
        <Typography variant="body2" style={{ color: '#666', lineHeight: 1.4 }}>
          {description}
        </Typography>
      </Box>
    </Box>
  );
}

const iconStyle = { color: '#ffffff', fontSize: 24 };

export const AppLandingPage: React.FC = () => {
  const platform = detectPlatform();

  const primaryStoreUrl = platform === 'ios' ? APP_STORE_URL : PLAY_STORE_URL;
  const primaryLabel = platform === 'ios' ? 'Kostenlos im App Store' : 'Kostenlos im Play Store';

  return (
    <Container maxWidth="sm">
      <Box py={4}>
        <Box textAlign="center" mb={4}>
          <Typography variant="h5" style={{ fontWeight: 700, color: '#3d5a80' }}>
            Pyramiden Cup App
          </Typography>
          <Typography variant="body1" style={{ color: '#666', marginTop: 8 }}>
            Alles was du brauchst, direkt am Handy.
          </Typography>
        </Box>

        <Box mb={4}>
          <FeatureItem
            icon={<NotificationsActiveIcon style={iconStyle} />}
            title="Push-Benachrichtigungen"
            description="Erfahre sofort, wenn dich jemand fordert oder ein Ergebnis eingetragen wird."
          />
          <FeatureItem
            icon={<ChangeHistoryIcon style={iconStyle} />}
            title="Pyramiden-Ansicht"
            description="Sieh die gesamte Rangliste als interaktive Pyramide mit Zoom und Schwenken."
          />
          <FeatureItem
            icon={<SportsKabaddiIcon style={iconStyle} />}
            title="Schneller fordern"
            description="Fordere Gegner mit einem Tap heraus und trage Ergebnisse direkt ein."
          />
          <FeatureItem
            icon={<BarChartIcon style={iconStyle} />}
            title="Persönliche Statistiken"
            description="Siege, Niederlagen, Siegquote und mehr auf einen Blick."
          />
          <FeatureItem
            icon={<SpeedIcon style={iconStyle} />}
            title="Schneller & flüssiger"
            description="Native Performance statt Browser. Startet sofort, kein Laden von Webseiten."
          />
          <FeatureItem
            icon={<DevicesIcon style={iconStyle} />}
            title="Mehrere Cups verwalten"
            description="Wechsle zwischen deinen Cups, ohne dich jedes Mal neu einzuloggen."
          />
        </Box>

        <Box textAlign="center">
          <Button
            variant="contained"
            size="large"
            href={primaryStoreUrl}
            style={{
              backgroundColor: '#ee6c4d',
              color: '#ffffff',
              fontWeight: 700,
              minWidth: 260,
              marginBottom: 12,
              fontSize: 16,
              padding: '12px 24px',
              borderRadius: 8,
            }}
          >
            {primaryLabel}
          </Button>

          {platform === 'unknown' && (
            <Box mt={1}>
              <Button
                variant="outlined"
                size="large"
                href={APP_STORE_URL}
                style={{
                  borderColor: '#3d5a80',
                  color: '#3d5a80',
                  fontWeight: 700,
                  minWidth: 260,
                }}
              >
                Im App Store laden
              </Button>
            </Box>
          )}

          <Typography variant="caption" style={{ display: 'block', marginTop: 16, color: '#999' }}>
            Kostenlos. Keine Werbung. Kein Abo.
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};
